import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "forgot-link" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = { class: "auth-switch" }
const _hoisted_8 = { class: "modal-content register-modal" }
const _hoisted_9 = { class: "step-indicator" }
const _hoisted_10 = {
  key: 0,
  class: "step-subtitle"
}
const _hoisted_11 = {
  key: 1,
  class: "step-subtitle"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "input-with-counter" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = {
  key: 0,
  class: "field-error"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "form-group cgu-group" }
const _hoisted_23 = { class: "cgu-checkbox" }
const _hoisted_24 = { class: "checkmark" }
const _hoisted_25 = { class: "cgu-text" }
const _hoisted_26 = {
  key: 0,
  class: "field-error"
}
const _hoisted_27 = { class: "form-actions" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 1,
  class: "step2-actions"
}
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 2,
  class: "error-message"
}
const _hoisted_32 = { class: "auth-switch" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showLoginModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModals && _ctx.closeModals(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "close-button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModals && _ctx.closeModals(...args)))
            }, "×"),
            _cache[25] || (_cache[25] = _createElementVNode("h2", null, "Connexion", -1)),
            _createElementVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Email ou numéro de téléphone",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginIdentifier) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.loginIdentifier]
                ])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  placeholder: "Mot de passe",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginPassword) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.loginPassword]
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: "/forgot-password",
                  onClick: _ctx.closeModals
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode(" Mot de passe oublié ? ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("button", {
                type: "submit",
                class: "submit-button",
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.loading ? 'Connexion...' : 'Se connecter'), 9, _hoisted_5)
            ], 32),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_7, [
              _cache[24] || (_cache[24] = _createTextVNode(" Pas encore de compte ? ", -1)),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchToRegister && _ctx.switchToRegister(...args)), ["prevent"]))
              }, "S'inscrire")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showRegisterModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal-overlay",
          onClick: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModals && _ctx.closeModals(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "close-button",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModals && _ctx.closeModals(...args)))
            }, "×"),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass(["step", { active: _ctx.registerStep === 1, completed: _ctx.registerStep > 1 }])
              }, [...(_cache[26] || (_cache[26] = [
                _createElementVNode("span", { class: "step-number" }, "1", -1),
                _createElementVNode("span", { class: "step-label" }, "Identifiants", -1)
              ]))], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["step-line", { active: _ctx.registerStep > 1 }])
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["step", { active: _ctx.registerStep === 2 }])
              }, [...(_cache[27] || (_cache[27] = [
                _createElementVNode("span", { class: "step-number" }, "2", -1),
                _createElementVNode("span", { class: "step-label" }, "Coordonnées", -1)
              ]))], 2)
            ]),
            _createElementVNode("h2", null, _toDisplayString(_ctx.registerStep === 1 ? 'Créer votre compte' : 'Informations de livraison'), 1),
            (_ctx.registerStep === 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Commencez par choisir vos identifiants de connexion "))
              : (_openBlock(), _createElementBlock("p", _hoisted_11, " Ces informations vous seront utiles pour vos futures commandes ")),
            _createElementVNode("form", {
              onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRegisterStep && _ctx.handleRegisterStep(...args)), ["prevent"]))
            }, [
              (_ctx.registerStep === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", null, "Pseudo", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Choisissez un pseudo",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.registerPseudo) = $event)),
                          maxlength: "12",
                          onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.truncatePseudo && _ctx.truncatePseudo(...args))),
                          required: ""
                        }, null, 544), [
                          [_vModelText, _ctx.registerPseudo]
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["char-counter", { warning: _ctx.registerPseudo.length >= 10, danger: _ctx.registerPseudo.length === 12 }])
                        }, _toDisplayString(_ctx.registerPseudo.length) + "/12 ", 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[29] || (_cache[29] = _createElementVNode("label", null, "Email", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        placeholder: "votre@email.com",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.registerEmail) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.registerEmail]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", null, "Mot de passe", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        placeholder: "8 caractères minimum",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.registerPassword) = $event)),
                        required: "",
                        onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.checkPasswordStrength && _ctx.checkPasswordStrength(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.registerPassword]
                      ]),
                      (_ctx.passwordError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.passwordError), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[31] || (_cache[31] = _createElementVNode("label", null, "Numéro de téléphone", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "tel",
                        placeholder: "06 XX XX XX",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.registerPhone) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.registerPhone]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[33] || (_cache[33] = _createElementVNode("label", null, "Ville", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.registerVille) = $event)),
                        required: ""
                      }, [...(_cache[32] || (_cache[32] = [
                        _createElementVNode("option", { value: "Libreville" }, "Libreville", -1),
                        _createElementVNode("option", { value: "Akanda" }, "Akanda", -1),
                        _createElementVNode("option", { value: "Owendo" }, "Owendo", -1)
                      ]))], 512), [
                        [_vModelSelect, _ctx.registerVille]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", null, "Quartier / Adresse", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        placeholder: "Ex: Montagne Sainte, PK8...",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.registerAdresse) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.registerAdresse]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("label", _hoisted_23, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.acceptCgu) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.acceptCgu]
                        ]),
                        _createElementVNode("span", _hoisted_24, [
                          (_ctx.acceptCgu)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: "check-square"
                              }))
                            : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 1,
                                icon: "square"
                              }))
                        ]),
                        _createElementVNode("span", _hoisted_25, [
                          _cache[37] || (_cache[37] = _createTextVNode(" J'accepte les ", -1)),
                          _createVNode(_component_router_link, {
                            to: "/conditions-generales",
                            target: "_blank",
                            onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                          }, {
                            default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                              _createTextVNode(" Conditions Générales d'Utilisation ", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[38] || (_cache[38] = _createTextVNode(" et la ", -1)),
                          _createVNode(_component_router_link, {
                            to: "/politique-confidentialite",
                            target: "_blank",
                            onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                          }, {
                            default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                              _createTextVNode(" Politique de Confidentialité ", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      (_ctx.cguError)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.cguError), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])),
              _createElementVNode("div", _hoisted_27, [
                (_ctx.registerStep === 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "submit-button next-btn",
                      onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.goToStep2 && _ctx.goToStep2(...args))),
                      disabled: !_ctx.isStep1Valid
                    }, " Suivant → ", 8, _hoisted_28))
                  : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "back-btn",
                        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.goToStep1 && _ctx.goToStep1(...args)))
                      }, " ← Retour "),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "submit-button",
                        disabled: _ctx.loading || !_ctx.acceptCgu
                      }, _toDisplayString(_ctx.loading ? 'Inscription...' : 'S\'inscrire'), 9, _hoisted_30)
                    ]))
              ])
            ], 32),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_32, [
              _cache[39] || (_cache[39] = _createTextVNode(" Déjà un compte ? ", -1)),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchToLogin && _ctx.switchToLogin(...args)), ["prevent"]))
              }, "Se connecter")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}